export const messages = {
  en: {
    goldWithdrawal: {
      queryCondition: 'Query Conditions',
      pleaseSelectAccountName: 'Please select account name',
      pleaseSelectWithdrawalAmount: 'Please select withdrawal amount',
      pleaseSelectApplicant: 'Please select applicant',
      pleaseSelectApplicantPhone: 'Please select applicant phone',
      query: 'Query',
      goldWithdrawal: 'Gold Withdrawal',
      applyWithdrawal: 'Apply Withdrawal',
      id: 'ID',
      goldId: 'Gold ID',
      accountName: 'Account Name',
      communityId: 'Community ID',
      withdrawalAmount: 'Withdrawal Amount',
      applicant: 'Applicant',
      applicantPhone: 'Applicant Phone',
      bankAccount: 'Bank Account',
      accountHolder: 'Account Holder',
      bankName: 'Bank Name',
      applicationDescription: 'Application Description',
      status: 'Status',
      auditDescription: 'Audit Description',
      operation: 'Operation',
      audit: 'Audit',
      delete: 'Delete',
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteGoldWithdrawal: 'Confirm to delete gold withdrawal',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete!',
      pleaseEnterAccountName: 'Required, please enter account name',
      approvedAndPaid: 'Approved and paid',
      rejected: 'Rejected',
      pleaseSelectStatus: 'Please select status',
      pleaseEnterWithdrawalAmount: 'Required, please enter withdrawal amount',
      pleaseEnterApplicant: 'Required, please enter applicant',
      pleaseEnterApplicantPhone: 'Required, please enter applicant phone',
      pleaseEnterApplicationDescription: 'Required, please enter application description',
      pleaseEnterAuditDescription: 'Required, please enter audit description',
      submit: 'Submit',
      auditSuccess: 'Audit success',
      auditFailed: 'Audit failed',
      deleteSuccess: 'Delete success',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    goldWithdrawal: {
      queryCondition: '查询条件',
      pleaseSelectAccountName: '请选择账户名称',
      pleaseSelectWithdrawalAmount: '请选择提现金额',
      pleaseSelectApplicant: '请选择申请人',
      pleaseSelectApplicantPhone: '请选择申请人电话',
      query: '查询',
      goldWithdrawal: '金币提现',
      applyWithdrawal: '申请提现',
      id: '编号',
      goldId: '金币ID',
      accountName: '账户名称',
      communityId: '小区编号',
      withdrawalAmount: '提现金额',
      applicant: '申请人',
      applicantPhone: '申请人电话',
      bankAccount: '银行账户',
      accountHolder: '账号名称',
      bankName: '开户行',
      applicationDescription: '申请说明',
      status: '状态',
      auditDescription: '审核说明',
      operation: '操作',
      audit: '审核',
      delete: '删除',
      confirmOperation: '请确认您的操作!',
      confirmDeleteGoldWithdrawal: '确定删除金币提现',
      cancel: '取消',
      confirmDelete: '确认删除!',
      pleaseEnterAccountName: '必填，请填写账户名称',
      approvedAndPaid: '同意并已打款',
      rejected: '拒绝',
      pleaseSelectStatus: '请审核',
      pleaseEnterWithdrawalAmount: '必填，请填写提现金额',
      pleaseEnterApplicant: '必填，请填写申请人',
      pleaseEnterApplicantPhone: '必填，请填写申请人电话',
      pleaseEnterApplicationDescription: '必填，请填写申请说明',
      pleaseEnterAuditDescription: '必填，请填写审核说明',
      submit: '提交',
      auditSuccess: '审核成功',
      auditFailed: '审核失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}